import React from 'react';

import {
  LandingSelectedEntities,
} from '../../../components';

const LandingSelectedStories = ({ id, entity }) => {

  return (
    <LandingSelectedEntities
      id={id}
      type="stories"
      link="/nl/verhalen"
      entities={entity.getIn(['field_landing_selected_stories'])}
      title={entity.getIn(['field_title', 0, 'value'])}
    />
  );
};

export default LandingSelectedStories;
